<template>
    <section class="d-flex justify-content-start flex-column flex-md-row justify-content-md-between align-items-start medico-row" style="border-bottom:1px #ccc dashed; padding: 5px 0px" v-if="medico">
        <div class="d-flex justify-content-between align-items-center medico-info">
            <div class="position-relative">
                <img :src="medico.foto" class="img-fluid rounded-circle foto-medico" :alt="medico.fullName" loading="lazy">
                <a :href="medico.url + '?request=video_consulti'" v-if="medico.existVideoconsulto" class="p-0 badge-videoconsulti" title="" data-toggle="tooltip" data-type="secondary" data-placement="top" data-original-title="Medico disponibile anche per VideoConsulti">
                    <img src="/images/frontend/videoconsulti_icon.svg" width="25" height="25" class="img-fluid rounded-circle" alt="Videoconsulti">
                </a>
            </div>
            <div class="w-100 ml-3">
                <h2 class="rfs-8 my-0 my-md-1">
                    <a :href="medico.url">
                        {{ medico.fullName }}
                    </a>
                </h2>
                <span class="text-muted">{{ medico.specializzazione_principale }}</span>
                <span class="d-flex flex-row align-items-center" @click="loadComments()" role="button" v-if="medico.datiSecondari.recensioni_numero">
                    <stars-component :value="(medico.datiSecondari.recensioni_media_medie / 2)"  /> <small><b>{{ medico.datiSecondari.recensioni_media_medie.number_format(1, '.', ',').replace('.0', '') }}</b></small> <small class="ml-1 text-muted" style="margin-left: 4px;font-size: 11.5px;margin-top: auto;margin-bottom: 1px;">({{ medico.datiSecondari.recensioni_numero }} recensioni)</small>
                </span>
            </div>
        </div>
        <div class="w-100 medico-prenota ml-md-2 mt-2 mt-md-0">
            <ul class="nav nav-tabs" v-if="showTabStudi">
                <li class="nav-item" v-for="(s, k) in medico.studi" :key="k + '-list-studi'">
                    <a href="javascript:;" class="nav-link tab-studio" @click.prevent="changeCurrentStudio(s)" :class="{'active': s == currentStudio}">
                        {{ s.name }}
                    </a>
                </li>
            </ul>
            <div class="elenco-studi list-unstyled mb-0 tab-content">
                <div class="studio-wrapper pb-1 pb-md-0 tab-pane fade'" :class="{'active': studio == currentStudio}" v-for="(studio, k) in medico.studi" :key="k + '-studio'" role="tabpanel">
                    <div class="studio-detail w-100 promo-price" :class="{'promo-price': studio.prestazioni[0].promozione ? true : false}">
                        <ul class="list-unstyled py-md-0 pl-md-0 py-lg-1 pl-lg-1 mb-0">
                            <li class="prestazione">
                                <div class="d-flex justify-content-between">
                                    <div class="align-self-end">
                                        <i class="fas fa-stethoscope fa-fw"></i> {{ studio.labelPrestazione }}
                                    </div>
                                    <div class="call-to-action" :class="{'promo-price': studio.prestazioni[0].promozione ? true : false}">
                                        <b class="ml-auto ml-lg-0 align-self-end pr-md-0 pr-lg-1 text-nowrap" v-html="studio.labelPrezzo">

                                        </b>
                                    </div>
                                </div>
                            </li>
                            <li v-if="studio.prestazioni[0].promozione">
                                <div class="text-promo small">
                                    <i class="fas fa-fw fapromo"></i> 
                                    <span v-html="studio.expiredPromotion"></span>
                                </div>
                            </li>
                            <li v-if="studio.pagamentoAnticipatoStudio">
                                <small class="footer-pagamento-anticipato text-muted">
                                    <i class="fas fa-credit-card fa-fw icon-pagamento-anticipato" aria-hidden="true"></i>  Risparmia il {{ studio.pagamento_anticipato_sconto }}% pagando online
                                </small>
                            </li>
                            <li class="studio" v-if="studio.tipo != 3">
                                <i class="fas fa-fw fa-map-marker-alt" aria-hidden="true"></i>&nbsp;<span v-html="studio.labelZona"></span>
                            </li>
                            <li>
                                <div class="d-flex justify-content-between align-items-start align-items-lg-center">
                                    <div class="text-muted first-disponibilita">
                                        <i class="far fa-calendar-alt fa-fw" aria-hidden="true">&nbsp;</i>
                                        <span class="d-inline text-capitalize align-middle rfs-5">
                                            <span v-if="studio.labelDisponibilita" v-html="studio.labelDisponibilita">
                                            </span>
                                            <span v-else>
                                                Su Richiesta
                                            </span>
                                        </span>
                                    </div>

                                    <div class="prenota-group" :class="{'nodisp': !studio.disponibilita}">
                                        <form method="GET" :action="medico.url + (!studio.disponibilita ? '' : '')">
                                            <input type="hidden" name="studio" :value="studio.ID">
                                            <input type="hidden" name="prestazione" :value="studio.prestazioni[0].prestazione_ID">
                                            <button v-if="studio.disponibilita" type="submit" class="btn btn-primary text-uppercase prenota-btn">Prenota</button>
                                            <button v-else type="submit" class="btn btn-outline-primary btn-sm text-uppercase prenota-btn btn-no-disp btn-richiedi-disp">{{ studio.id_clinica ? 'chiedi appuntamento' : 'richiedi disponibilità' }}</button>
                                        </form>                                        
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import StarsComponent from '../../components/StarsComponent.vue';
export default {
    components: { StarsComponent },
    props: {
        medico: null,
    },
    data: function() {
        return {
            currentStudio: null,
        }
    },
    watch: {
    },
    computed: {
        isClinica: function() {
            return this.medico.type === "App\\Models\\ClinicaRowMedico";
        },
        showTabStudi: function () {
            return (this.medico.tipoDomicilioCount + this.medico.tipoStudioCount + this.medico.tipoVideoconsultoCount) > 1;
        },
    },
    mounted() {
        this.currentStudio = this.medico.studi[0];
    },
    methods: {
        changeCurrentStudio: function(studio) {
            this.currentStudio = studio;
        },
        loadComments: async function ()
        {
            loadComments(this.medico.ID, this.medico.mediaReviews, (this.isClinica ? 'Clinica' : 'Medico'));
        }
    }
}
</script>
<style lang="scss" scoped>
.medico-row {
    .medico-info {
        width: 100%;
        max-width: 310px;
        img.foto-medico {
            transition: box-shadow .3s ease-in-out;
            -webkit-box-shadow: 1px 8px 10px -6px #6c757d;
            box-shadow: 1px 8px 10px -6px #6c757d;
            aspect-ratio: 1 / 1;
            max-width: 65px;
            max-height: 65px;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .badge-videoconsulti {
            position: absolute;
            left: 0px;
            bottom: -6px;
        }
        h2 {
            font-size: 20px;
            line-height: normal;
            font-family: inherit;
            font-weight: 400;
        }
        ::v-deep .rate {
            font-size: 14px;
            text-decoration: none;
            font-weight: 300;
            margin-bottom: 0px;
            li {
                margin-right: 0px;
                i {
                    width: 1.25em;
                    font-size: 87% !important;
                    color: #fcbc00 !important;
                }
            }
        }
    }
    .medico-prenota {
        ::v-deep .studio-via {
            display: block;
            margin-left: 24px;
            .hide-me {
                display: none;
            }
        }
        .elenco-studi {
            li {
                &.studio-wrapper {
                    border-bottom: 1px dashed #ccc;
                    transition: background .25s linear;
                    &:hover {
                        background: linear-gradient(90deg,rgb(255 255 255/0%) 0%,rgb(193 193 193/15%) 50%,rgba(255,255,255,0) 100%) !important;
                        cursor: pointer;
                    }
                    &:last-child {
                        border: none;
                    }
                    .liste-citta-zona {
                        font-size: 90%;
                        color: #6c757d;
                        &::before {
                            content: " - ";
                        }
                    }
                }
            }
        }

        .nav-tabs {
            border: none !important;
            margin-top: 3px;
            margin-bottom: 10px;
            .nav-item {
                margin-right: 13px;
                .nav-link {
                    margin: 0;
                    height: 26px;
                    font-size: 15px;
                    border: none;
                    border-bottom: 2px solid transparent;
                    padding: 0 7px;

                    &.active {
                        border-bottom: 2px solid #2c6fb9;
                        font-weight: 500;
                    }
                }
            }
        }
    }
}
</style>